import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StyleHelper {
    public parse(json: string): any {
        if (!json) {
            return null;
        }

        try {
            return JSON.parse(json.replace(/url/ig, ''));
        } catch (e) {
            return null;
        }
    }
}
